export default {
      id: "facebook-usage",
      viewBox: "0 0 13 25",
      url: __webpack_public_path__ + "img/icons.svg#facebook",
      toString: function () {
        return this.url;
      }
    }